export const toast = () => {
  const toastButtons = document.querySelectorAll( '.js-toastClose' );

  toastButtons.forEach( item => {
    item.addEventListener( 'click', () => {
      item.closest( '.p-toast' ).style.display = 'none';
    } );
  } );
}
